import React from "react";
import { Mail, Instagram, Clock } from "lucide-react";
import { RevealText, Reveal } from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  return (
    <div className="pt-8 md:pt-12">
      <section className="mx-auto max-w-[1400px] px-6 md:px-10">
        <p className="overline text-sage mb-6">Contact</p>
        <RevealText
          as="h1"
          className="font-serif font-light text-ink leading-[0.95] tracking-tight text-5xl sm:text-6xl md:text-7xl"
          lines={["Let's begin", "your story"]}
        />
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 mt-16 pb-28 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
        <Reveal className="lg:col-span-4">
          <p className="text-inksoft leading-relaxed max-w-sm">
            Tell me a little about what you&rsquo;re dreaming up. I read every message
            personally and reply within two business days.
          </p>
          <div className="mt-12 space-y-6">
            <a
              href="mailto:info@jacquelineclairephoto.com"
              className="flex items-center gap-4 text-ink hover:text-sage transition-colors"
            >
              <Mail size={18} className="text-sage" /> info@jacquelineclairephoto.com
            </a>
            <a
              href="https://instagram.com/jacclairephotos"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 text-ink hover:text-sage transition-colors"
            >
              <Instagram size={18} className="text-sage" /> @jacclairephotos
            </a>
            <p className="flex items-center gap-4 text-inksoft">
              <Clock size={18} className="text-sage" /> Tue – Sat, by appointment
            </p>
          </div>
          <div className="mt-12 aspect-square rounded-tr-[4rem] bg-sagelight hidden lg:block" />
        </Reveal>

        <Reveal className="lg:col-span-8" delay={0.1}>
          <ContactForm testIdPrefix="contact" />
        </Reveal>
      </section>
    </div>
  );
}
